module.exports = __webpack_public_path__ + "img/img_cs_phone_img5.5db4c570.png";